import { Component, OnInit } from '@angular/core';
import { RestapiService } from '../../services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent implements OnInit {

  constructor(
    public api: RestapiService,
    public seo: SeoService
  ) { }

  ngOnInit(): void {
    this.seo.generateTags({
      title:'WWF Educación Ambiental, Contactos',
      description: 'Contactos',
      image: '/assets/brand.png',
      slug: window.location.href,
    });
  }

}
